
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import styles from './index.module.scss';
import Layout from '@/layouts/simple';
import { WeeeIcon } from '@/components/common/Icon';
import { EnvelopeOutline, InfoOutline } from '@weee-fe/kunlunicon';
import { GlobalEmptyComponent } from '@/components/common/GlobalComponent';
import classNames from 'classnames';
import { isLatinoChannel } from '@/utils/common/latino-app';

const suppliersEmail = 'suppliers@masgusto.com';
const adsEmail = 'ads@masgusto.com';
export default function ContactUs() {
  const { t } = useTranslation('common');
  const isLatino = isLatinoChannel();
  return (
    <Layout title={`${t('common_contact_us')}`}>
      <div className={styles.contactUsContainer}>
        <div className={styles.contactUsItem}>
          <div className={classNames(styles.contactUsTitle, styles.contactUsTitleYellow)}>{`${t(
            'home_partners'
          )}`}</div>
          <div className={styles.contactUsWords}>
            <EnvelopeOutline className={styles.antdIcon} />
            <a href={`mailto:${suppliersEmail}`} className={styles.commonA}>
              <div className={`${styles.makeFlex}`}>
                <span>
                  <strong>{`${t('home_partners_supply')}`}</strong>
                  {suppliersEmail}
                </span>
                <WeeeIcon type={'iconArrowRight'} className={`${styles.commonArrows}`} />
              </div>
            </a>
          </div>
          {!isLatino && (
            <div className={styles.contactUsWords}>
              <EnvelopeOutline className={styles.antdIcon} />
              <a href="mailto:marketplace@sayweee.com" className={styles.commonA}>
                <div className={`${styles.makeFlex}`}>
                  <span>
                    <strong>{t('marketplace_contact_us_label')}</strong>marketplace@sayweee.com
                  </span>
                  <WeeeIcon type={'iconArrowRight'} className={`${styles.commonArrows}`} />
                </div>
              </a>
            </div>
          )}
          <div className={styles.contactUsWords}>
            <EnvelopeOutline className={styles.antdIcon} />
            <a href={`mailto:${adsEmail}`} className={styles.commonA}>
              <div className={styles.makeFlex}>
                <span>
                  <strong>{`${t('home_partners_ad')}`}</strong>
                  {adsEmail}
                </span>
                <WeeeIcon type={'iconArrowRight'} className={styles.commonArrows} />
              </div>
            </a>
          </div>
          {!isLatino && (
            <div className={styles.contactUsWords}>
              <InfoOutline className={styles.antdIcon} />
              <a href="https://www.sayweee.com/company/sell-on-weee" className={styles.commonA}>
                <div className={styles.makeFlex}>
                  <span>{`${t('footer_sell_with_us')}`}</span>
                  <WeeeIcon type={'iconArrowRight'} className={styles.commonArrows} />
                </div>
              </a>
            </div>
          )}
          {!isLatino && (
            <div className={styles.contactUsWords}>
              <InfoOutline className={styles.antdIcon} />
              <a href="https://www.sayweee.com/company/partners" className={styles.commonA}>
                <div className={styles.makeFlex}>
                  <span>{`${t('footer_partner_with_us')}`}</span>
                  <WeeeIcon type={'iconArrowRight'} className={styles.commonArrows} />
                </div>
              </a>
            </div>
          )}
          {!isLatino && (
            <div className={styles.contactUsWords}>
              <InfoOutline className={styles.antdIcon} />
              <a href="https://www.sayweee.com/company/press-and-media" className={styles.commonA}>
                <div className={styles.makeFlex}>
                  <span>{`${t('footer_about_media')}`}</span>
                  <WeeeIcon type={'iconArrowRight'} className={styles.commonArrows} />
                </div>
              </a>
            </div>
          )}
        </div>
        {!isLatino && (
          <div className={styles.contactUsItem}>
            <div className={classNames(styles.contactUsTitle, styles.contactUsTitleGreen)}>{`${t('home_career')}`}</div>
            <div className={styles.contactUsWords}>
              <InfoOutline className={styles.antdIcon} />
              <a href="https://www.sayweee.com/company/careers" className={styles.commonA}>
                <div className={styles.makeFlex}>
                  <span>{`${t('home_weee_workable')}`}</span>
                  <WeeeIcon type={'iconArrowRight'} className={styles.commonArrows} />
                </div>
              </a>
            </div>
            <div className={styles.contactUsWords}>
              <InfoOutline className={styles.antdIcon} />
              <a href="https://www.sayweee.com/company/drivers" className={styles.commonA}>
                <div className={styles.makeFlex}>
                  <span>{`${t('home_become_driver')}`}</span>
                  <WeeeIcon type={'iconArrowRight'} className={styles.commonArrows} />
                </div>
              </a>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}

ContactUs.GlobalComponent = GlobalEmptyComponent;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/account/contact-us/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  